import { createContext, useContext } from "react";

export const ConnectPopoverContext = createContext(false);
ConnectPopoverContext.displayName = "ConnectPopoverContext";

export const useIsConnectPopoverPanel = () => useContext(ConnectPopoverContext);
